<img [src]="icon.src" [alt]="icon.src"
     [style.filter]="invert ? 'invert(1)' : 'invert(0)'"
>
